<div class="landing-page surface-0 text-900">
    <!-- Topbar -->
    <header class="landing-topbar surface-0 shadow-2 px-4 md:px-6 lg:px-8">
        <div class="landing-container flex align-items-center justify-content-between py-3">
            <div class="flex align-items-center gap-3">
                <img src="assets/layout/images/sf-logoTabellio.png" [attr.alt]="'landing.brand.alt' | translate" height="44" />
                <div class="text-xl font-semibold">
                    <span class="text-900">Cartório Fácil</span>
                    <span class="text-orange-500"> Online</span>
                </div>
            </div>

            <a class="cursor-pointer block lg:hidden text-700" pStyleClass="@next" enterClass="hidden" enterActiveClass="fadein" leaveToClass="hidden" leaveActiveClass="fadeout">
                <i class="pi pi-bars text-3xl"></i>
            </a>

            <div class="landing-menu-mobile hidden lg:hidden pb-4 border-top-1 surface-border">
                <button pButton pRipple class="p-button-text w-full justify-content-start" [label]="'landing.nav.services' | translate" (click)="scrollTo('services')"></button>
                <button pButton pRipple class="p-button-text w-full justify-content-start" [label]="'landing.nav.plans' | translate" (click)="scrollTo('plans')"></button>
                <button pButton pRipple class="p-button-text w-full justify-content-start" [label]="'landing.nav.contact' | translate" (click)="scrollTo('contact')"></button>
                <button pButton pRipple class="p-button-outlined w-full justify-content-start" icon="pi pi-user" [label]="'label.login' | translate" (click)="navigateToLogin()"></button>
                <button pButton pRipple class="w-full justify-content-start" icon="pi pi-user-plus" [label]="'landing.nav.signup' | translate" (click)="navigateToSignup()"></button>
            </div>

            <div class="landing-menu hidden lg:flex align-items-center gap-4">
                <button pButton pRipple class="p-button-text" [label]="'landing.nav.services' | translate" (click)="scrollTo('services')"></button>
                <button pButton pRipple class="p-button-text" [label]="'landing.nav.plans' | translate" (click)="scrollTo('plans')"></button>
                <button pButton pRipple class="p-button-text" [label]="'landing.nav.contact' | translate" (click)="scrollTo('contact')"></button>
                <button pButton pRipple class="p-button-outlined" icon="pi pi-user" [label]="'label.login' | translate" (click)="navigateToLogin()"></button>
                <button pButton pRipple icon="pi pi-user-plus" [label]="'landing.nav.signup' | translate" (click)="navigateToSignup()"></button>
            </div>
        </div>
    </header>

    <!-- Hero Section with Gradient Background -->
    <section class="modern-saas-hero px-4 py-8 md:px-6 lg:px-8">
        <div class="landing-container">
            <div class="grid align-items-center">
                <div class="col-12 md:col-5">
                    <div class="hero-content">
                        <h1 class="hero-title text-5xl md:text-5xl font-bold mb-4 text-center">
                            Resolva assuntos de cartório sem filas, sem confusão e sem perder tempo. Tudo na palma da sua mão.
                        </h1>
                        <p class="hero-description text-2xl text-white line-height-3 mb-5">Escolha o cartório mais próximo, envie seus documentos online, acompanhe cada etapa e fale direto com o responsável pelo seu pedido via Chat.</p>
                        <div class="subscribe-form mb-4">
                            <form class="subscribe-form-wrapper m-0">
                                <input type="email" pInputText placeholder="seu@email.com" class="subscribe-input" />
                                <button pButton pRipple icon="pi pi-arrow-right" iconPos="right"
                                    [label]="'landing.hero.ctaPrimary' | translate"
                                    class="subscribe-button"
                                    type="button"
                                    (click)="navigateToSignup()"></button>
                            </form>
                        </div>

                    </div>
                </div>
                <div class="col-12 md:col-7 mt-7 md:mt-0">
                    <div class="hero-image-wrapper position-relative">
                        <div class="hero-bg-image" [style.background-image]="'url(assets/images/landing/cartorio-hero.jpg)'" width="100%" height="100%"></div>
                        <!-- Decorative Dots -->
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Partners Section
    <section class="partners-section px-4 py-4">
        <div class="landing-container">
            <div class="grid justify-content-center">
                <div class="col-6 md:col-2 text-center py-3" *ngFor="let partner of partners">
                    <img [src]="partner.logo" [alt]="partner.name" class="partner-logo" />
                </div>
            </div>
        </div>
    </section> -->

<!-- Section Start -->
<section class="section pt-md-4 pt-5">
    <!-- Start Features -->
    <div class="landing-container">
        <div class="grid justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h2 class="title mb-4">Você resolve com clareza, rapidez e controle</h2>
                    <p class="text-muted para-desc mx-auto mb-0 text-xl">A tecnologia só facilita — a execução e a validação final continuam sendo feitas pelo cartório parceiro.</p>
                </div>
            </div>
        </div>

        <div class="grid">
            <div class="col-12 md:col-6 lg:col-4 mt-5 pt-4" *ngFor="let benefit of benefits">
                <div class="features feature-primary text-center">
                    <div class="image position-relative d-inline-block">
                        <i [class]="benefit.icon + ' h2 text-orange-500 text-4xl'"></i>
                    </div>
                    <div class="content mt-4">
                        <h4 class="text-2xl font-bold">{{ benefit.title }}</h4>
                        <p class="text-muted mb-0 text-xl  ">{{ benefit.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>
    <!-- End Features -->


    <!-- Features Section -->
    <section class="features-section surface-section px-4 py-8 md:px-6 lg:px-8">
        <div class="landing-container">
            <div class="section-header text-center mb-6">

                <h2 class="section-title text-4xl font-bold mb-3 text-orange-500">
                    CartórIA
                </h2>
                <p class="section-subtitle text-2xl">Sua assistente virtual de serviços cartoriais</p>
            </div>





            <div class="grid">
                <div class="col-12 md:col-6 lg:col-7 mt-4">
                    <div class="feature-image-wrapper position-relative">
                        <img src="assets/images/landing/cartoria.jpg" alt="" class="feature-image w-full border-round shadow-4" />
                        <div class="feature-shape-left"></div>
                    </div>
                </div>
                <div class="col-12 md:col-6 lg:col-5 mt-4">
                    <div class="feature-content">


                            <div class="section-title ms-lg-5">

                                <p class="text-xl mb-4">CartórIA é a assistente inteligente que guia você em cada etapa do processo cartorial, evitando erros, atrasos e deslocamentos desnecessários.</p>
                                <ul class="list-none mb-0 text-muted text-xl">
                                    <li class="mb-3"><span class="text-orange-500 h5 me-2 mr-2"><i class="text-2xl  pi pi-check-circle align-middle"></i></span>Tira dúvidas em linguagem simples</li>
                                    <li class="mb-3"><span class="text-orange-500 h5 me-2 mr-2"><i class="text-2xl pi pi-check-circle align-middle"></i></span>Verifica documentos automaticamente (legibilidade e itens obrigatórios)</li>
                                    <li class="mb-3"><span class="text-orange-500 h5 me-2 mr-2"><i class="text-2xl pi pi-check-circle align-middle"></i></span>Reduz erros que geram retrabalho</li>
                                    <li class="mb-3"><span class="text-orange-500 h5 me-2 mr-2"><i class="text-2xl pi pi-check-circle align-middle"></i></span>Acelera o fluxo com automações</li>
                                </ul>
                                <div class="mt-5 p-3 bg-orange-50 border-round border-left-3 border-orange-500 text-xl">
                                    <strong>Importante:</strong> a decisão final e a execução do serviço continuam sendo realizadas pelo cartório parceiro.
                                </div>
                            </div>
                    </div>
                </div>
            </div>


        </div>
    </section>

    <!-- Pricing Section -->
    <section id="plans" class="pricing-section surface-section px-4 py-8 md:px-6 lg:px-8">
        <div class="landing-container">
            <div class="section-header text-center mb-6">
                <h2 class="section-title text-4xl font-bold mb-4">Planos e Preços</h2>
                <p class="section-subtitle text-600 text-xl">Escolha o plano ideal para o seu perfil.</p>
            </div>
            <div class="grid justify-content-center">
                <div class="col-12 md:col-6 lg:col-4 mt-4 pt-2" *ngFor="let plan of plans">
                    <div class="pricing-card-developer card border-0 p-4 h-full rounded-md shadow-2" [class.pricing-featured]="plan.featured">
                        <div *ngIf="plan.badge" class="pricing-ribbon pricing-ribbon-right">
                            <span class="ribbon-text">{{ plan.badge | translate }}</span>
                        </div>
                        <div class="card-body p-0">
                            <span class="pricing-badge py-2 px-4 d-inline-block mb-0 mt-0">{{ plan.name | translate }}</span>
                            <div class="pricing-price-wrapper mt-3 mb-0">
                                <h2 class="pricing-price-amount font-bold mb-0">{{ plan.price }}</h2>
                                <p class="pricing-price-period text-600 mb-0">Por Mês</p>
                            </div>
                            <p class="pricing-description text-600 mb-0 mt-3">{{ plan.description | translate }}</p>
                            <ul class="pricing-features-list list-none p-0 m-0 pt-3 border-top mt-3 mb-0">
                                <li class="pricing-feature-item mb-0 flex align-items-start" *ngFor="let feature of plan.features">
                                    <i class="pi pi-check-circle text-orange-500 mr-2 mt-1"></i>
                                    <span class="text-600">{{ feature | translate }}</span>
                                </li>
                            </ul>
                            <div class="pricing-cta mt-4">
                                <button pButton pRipple
                                    [class]="plan.featured ? 'w-full' : 'p-button-outlined w-full'"
                                    [label]="plan.cta | translate"
                                    (click)="plan.featured ? navigateToSignup() : scrollTo('contact')"></button>
                                <p class="text-600 text-sm mt-3 mb-0 text-center">*Sem necessidade de cartão de crédito</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Services Section -->
    <section id="services" class="services-section surface-section px-4 py-8 md:px-6 lg:px-8">
        <div class="landing-container">
            <div class="section-header text-center mb-6">
                <h2 class="section-title text-4xl text-orange-500 font-bold mb-3">Serviços mais solicitados</h2>
                <p class="section-subtitle text-600 text-lg">Tudo o que você precisa para resolver documentos com praticidade.</p>
            </div>
            <div class="grid">
                <div class="col-12 md:col-6 lg:col-4" *ngFor="let service of services">
                    <div class="service-card card p-4 h-full">
                        <div class="service-icon-wrapper mb-3">
                            <i [class]="service.icon + ' text-orange-500 text-4xl'"></i>
                        </div>
                        <h3 class="text-xl font-semibold mb-2">{{ service.title | translate }}</h3>
                        <p class="text-600 line-height-3">{{ service.description | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Contact Section -->
    <section id="contact" class="contact-section surface-section px-4 py-8 md:px-6 lg:px-8">
        <div class="landing-container">
            <div class="grid align-items-center">
                <div class="col-12 lg:col-5">
                    <span class="text-orange-500 font-semibold text-2xl">Fale conosco</span>
                    <h2 class="text-2xl font-bold mt-2 mb-4">{{ 'landing.contact.title' | translate }}</h2>
                    <p class="text-600 line-height-3 mb-5">Nosso time responde rápido e orienta o melhor caminho.</p>
                    <div class="contact-info">
                        <div class="contact-item mb-4">
                            <i class="pi pi-envelope text-primary text-xl mr-3"></i>
                            <span class="text-600">{{ 'landing.contact.email' | translate }}</span>
                        </div>
                        <div class="contact-item mb-4">
                            <i class="pi pi-phone text-primary text-xl mr-3"></i>
                            <span class="text-600">(31) 99999-9999</span>
                        </div>
                        <div class="contact-item">
                            <i class="pi pi-map-marker text-primary text-xl mr-3"></i>
                            <span class="text-600">Belo Horizonte -MG, Brasil</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-7">
                    <div class="contact-form-card card p-5">
                        <div class="field mb-4">
                            <label for="name" class="font-medium block mb-2">{{ 'landing.contact.form.name' | translate }}</label>
                            <input id="name" type="text" pInputText class="w-full" />
                        </div>
                        <div class="field mb-4">
                            <label for="email" class="font-medium block mb-2">{{ 'landing.contact.form.email' | translate }}</label>
                            <input id="email" type="email" pInputText class="w-full" />
                        </div>
                        <div class="field mb-4">
                            <label for="message" class="font-medium block mb-2">{{ 'landing.contact.form.message' | translate }}</label>
                            <textarea id="message" rows="5" pInputTextarea class="w-full"></textarea>
                        </div>
                        <button pButton pRipple class="w-full" icon="pi pi-send" [label]="'landing.contact.form.submit' | translate"></button>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Footer -->
    <footer class="landing-footer surface-900 text-100 px-4 py-6 md:px-6 lg:px-8">
        <div class="landing-container grid align-items-center">
            <div class="col-12 md:col-6">
                <div class="flex align-items-center gap-3">
                    <img src="assets/layout/images/sf-logoTabellio.png" [attr.alt]="'landing.brand.alt' | translate" height="36" />
                    <span class="text-sm">{{ 'landing.footer.about' | translate }}</span>
                </div>
            </div>
            <div class="col-12 md:col-6 text-left md:text-right mt-4 md:mt-0">
                <span class="text-sm">{{ 'landing.footer.rights' | translate }}</span>
            </div>
        </div>
    </footer>
</div>
